import VueI18n from 'vue-i18n';
import sharedFr from '@/shared/language/fr';
import sharedEn from '@/shared/language/en';
import fr from '@/languages/fr';
import en from '@/languages/en';
import Vue from 'vue';
import merge from 'lodash/merge';

Vue.use(VueI18n);

const localeMessages = {
  fr: merge(sharedFr, fr),
  en: merge(sharedEn, en),
};
const i18n = new VueI18n({ locale: 'fr', fallbackLocale: 'fr', messages: localeMessages });

export default i18n;
